(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Icons", [], factory);
	else if(typeof exports === 'object')
		exports["Icons"] = factory();
	else
		root["Icons"] = factory();
})(this, function() {
return 